import styled from 'styled-components';

export const RoutingRuleFooterStyled = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;

export const RoutingRuleFooterRight = styled.div`
  display: flex;
  column-gap: 20px;
`;
